module.exports = __webpack_public_path__ + "static/media/ecommerce-img-01.69c2907d.png";